(function () {
    if (window.__tlDiscountBoxLoaded) return;
    window.__tlDiscountBoxLoaded = true;

    var LOG_PREFIX = '[Discount box]';
    var BOX_CLASS = 'tl-discount-box';
    var TEXTS = {
        en: {
            placeholder: 'Discount code',
            apply: 'Apply',
            empty: 'Please enter a discount code.',
            invalid: 'This discount code is not valid for your cart.',
            alreadyApplied: 'This discount code is already applied.',
            applied: 'Discount code applied.',
            error: 'Something went wrong. Please try again.',
            remove: 'Remove'
        },
        pt: {
            placeholder: 'Código de desconto',
            apply: 'Aplicar',
            empty: 'Digite um código de desconto.',
            invalid: 'Este código de desconto não é válido para o seu carrinho.',
            alreadyApplied: 'Este código de desconto já foi aplicado.',
            applied: 'Código de desconto aplicado.',
            error: 'Algo deu errado. Tente novamente.',
            remove: 'Remover'
        },
        vi: {
            placeholder: 'Mã giảm giá',
            apply: 'Áp dụng',
            empty: 'Vui lòng nhập mã giảm giá.',
            invalid: 'Mã giảm giá không hợp lệ với giỏ hàng của bạn.',
            alreadyApplied: 'Mã giảm giá này đã được áp dụng.',
            applied: 'Đã áp dụng mã giảm giá.',
            error: 'Đã có lỗi xảy ra. Vui lòng thử lại.',
            remove: 'Xoá'
        }
    };

    var config = Object.assign({
        enabled: true,
        cartDrawer: true,
        cartPage: true,
        // Checkout buttons: the box is inserted right before the first one in each drawer / cart form
        checkoutSelector: 'button[name="checkout"], input[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"], #cart-sidebar-checkout',
        // Elements that wrap the cart drawer
        drawerSelector: 'cart-drawer, cart-drawer-component, #CartDrawer, #cart-drawer, #sidebar-cart, #halo-cart-sidebar, .cart-drawer, .drawer--cart, [data-cart-drawer]',
        insertBefore: null,
        appendTo: null,
        itemsListSelector: null,
        refreshCart: null,
        texts: {},
        debug: false
    }, window.tlDiscountBoxConfig || {});

    var locale = String((window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    var texts = Object.assign({}, TEXTS.en, TEXTS[locale] || {}, config.texts);

    var MESSAGE_STORAGE_KEY = 'tl-discount-box-message';
    var MESSAGE_DURATION = 8000;
    var lastCart = null;
    var lastMessage = null; // kept so the message survives the cart re-render / a page reload
    var isApplying = false;

    try {
        lastMessage = JSON.parse(sessionStorage.getItem(MESSAGE_STORAGE_KEY) || 'null');
        sessionStorage.removeItem(MESSAGE_STORAGE_KEY);
    } catch (error) {
        lastMessage = null;
    }

    function log() {
        if (config.debug) console.log.apply(console, [LOG_PREFIX].concat([].slice.call(arguments)));
    }

    function getRoot() {
        return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    function getThemeName() {
        return (window.Shopify && window.Shopify.theme && window.Shopify.theme.schema_name) || '';
    }

    function isCartPage() {
        return /\/cart\/?$/.test(window.location.pathname);
    }

    // ---- Cart API ----
    // `app=salepify` keeps other cart scripts that intercept cart requests from reacting to them
    async function fetchCart() {
        var res = await fetch(getRoot() + 'cart.js?app=salepify', { headers: { Accept: 'application/json' } });
        if (!res.ok) throw new Error('Cannot load cart');
        lastCart = await res.json();
        return lastCart;
    }

    async function setDiscountCodes(codes) {
        var res = await fetch(getRoot() + 'cart/update.js?app=salepify', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: codes.join(',') })
        });
        if (!res.ok) throw new Error('Cannot update discount codes');
        lastCart = await res.json();
        return lastCart;
    }

    function isSameCode(a, b) {
        return String(a).trim().toLowerCase() === String(b).trim().toLowerCase();
    }

    // ---- Styles ----
    function injectStyle() {
        if (document.getElementById(BOX_CLASS + '-style')) return;
        var style = document.createElement('style');
        style.id = BOX_CLASS + '-style';
        style.textContent = [
            // Layout rules use !important: theme styles for input / button (margin, height, line-height...) must not misalign the row
            '.tl-discount-box{display:block!important;width:100%!important;box-sizing:border-box!important;margin:12px 0!important;padding:0!important;font-size:14px;text-align:left}',
            '.tl-discount-box--in-list{flex:0 0 auto!important;margin:0!important;padding:var(--tl-db-list-padding,4px 0 12px)!important}',
            '.tl-discount-box__form{display:flex!important;flex-direction:row!important;flex-wrap:nowrap!important;align-items:stretch!important;gap:8px!important;width:100%!important;margin:0!important;padding:0!important}',
            '.tl-discount-box__input,.tl-discount-box__apply{box-sizing:border-box!important;height:44px!important;min-height:44px!important;max-height:44px!important;margin:0!important;line-height:normal!important;vertical-align:middle!important;-webkit-appearance:none!important;appearance:none!important;box-shadow:none!important;transform:none!important;position:static!important;top:auto!important}',
            '.tl-discount-box__input{flex:1 1 auto!important;width:auto!important;min-width:0!important;max-width:none!important;padding:0 12px!important;border:1px solid var(--tl-db-border,rgba(0,0,0,.25))!important;border-radius:var(--tl-db-radius,4px)!important;background:var(--tl-db-input-bg,#fff)!important;color:var(--tl-db-input-color,#111)!important;font:inherit;font-size:14px!important;text-transform:uppercase;outline-offset:0}',
            '.tl-discount-box__input::placeholder{text-transform:none;opacity:.6}',
            '.tl-discount-box__apply{flex:0 0 auto!important;width:auto!important;min-width:0!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;padding:0 18px!important;border:0!important;border-radius:var(--tl-db-radius,4px)!important;background:var(--tl-db-btn-bg,#111)!important;color:var(--tl-db-btn-color,#fff)!important;font:inherit;font-size:14px!important;letter-spacing:normal;cursor:pointer;white-space:nowrap!important}',
            '.tl-discount-box__apply[disabled]{opacity:.6;cursor:default}',
            '.tl-discount-box__message{margin:6px 0 0!important;padding:0!important;font-size:13px}',
            '.tl-discount-box__message[hidden]{display:none!important}',
            '.tl-discount-box__message--error{color:var(--tl-db-error,#d72c0d)}',
            '.tl-discount-box__message--success{color:var(--tl-db-success,#108043)}',
            '.tl-discount-box__codes{display:flex!important;flex-wrap:wrap;gap:6px;margin:8px 0 0!important;padding:0!important;list-style:none!important}',
            '.tl-discount-box__codes:empty{display:none!important}',
            '.tl-discount-box__code{display:inline-flex!important;align-items:center;gap:6px;margin:0!important;padding:4px 10px!important;border-radius:999px;background:var(--tl-db-tag-bg,rgba(0,0,0,.06));font-size:13px}',
            '.tl-discount-box__code::before,.tl-discount-box__code::marker{content:none!important}',
            '.tl-discount-box__remove{width:auto!important;height:auto!important;min-height:0!important;margin:0!important;padding:0!important;border:0!important;background:none!important;color:inherit!important;font-size:16px!important;line-height:1!important;cursor:pointer}'
        ].join('');
        document.head.appendChild(style);
    }

    // ---- Messages / applied codes ----
    function showMessage(box, text, type) {
        var message = box.querySelector('.' + BOX_CLASS + '__message');
        if (!message) return;
        message.className = BOX_CLASS + '__message' + (type ? ' ' + BOX_CLASS + '__message--' + type : '');
        message.textContent = text || '';
        message.hidden = !text;
    }

    // Kept for the boxes created after the cart is re-rendered (and saved in case the page reloads)
    function saveMessage(text, type) {
        lastMessage = text ? { text: text, type: type, time: Date.now() } : null;
        try {
            if (lastMessage) sessionStorage.setItem(MESSAGE_STORAGE_KEY, JSON.stringify(lastMessage));
            else sessionStorage.removeItem(MESSAGE_STORAGE_KEY);
        } catch (error) {}
    }

    function showMessageInAllBoxes(text, type) {
        saveMessage(text, type);
        document.querySelectorAll('.' + BOX_CLASS).forEach(function (box) { showMessage(box, text, type); });
        scheduleFit();
    }

    function setLoading(loading) {
        isApplying = loading;
        document.querySelectorAll('.' + BOX_CLASS + '__apply, .' + BOX_CLASS + '__remove').forEach(function (button) {
            button.disabled = loading;
        });
    }

    function renderAppliedCodes() {
        var codes = ((lastCart && lastCart.discount_codes) || []).filter(function (discount) { return discount.applicable; });

        document.querySelectorAll('.' + BOX_CLASS + '__codes').forEach(function (list) {
            list.innerHTML = '';
            codes.forEach(function (discount) {
                var item = document.createElement('li');
                item.className = BOX_CLASS + '__code';

                var label = document.createElement('span');
                label.textContent = discount.code;

                var remove = document.createElement('button');
                remove.type = 'button';
                remove.className = BOX_CLASS + '__remove';
                remove.setAttribute('aria-label', texts.remove + ' ' + discount.code);
                remove.innerHTML = '&times;';
                remove.disabled = isApplying;
                remove.addEventListener('click', function () { removeDiscountCode(discount.code); });

                item.appendChild(label);
                item.appendChild(remove);
                list.appendChild(item);
            });
        });
        scheduleFit();
    }

    // ---- Apply / remove ----
    async function applyDiscountCode(code) {
        code = String(code || '').trim();
        if (!code) return showMessageInAllBoxes(texts.empty, 'error');
        if (isApplying) return;

        setLoading(true);
        try {
            var cart = await fetchCart();
            var currentCodes = (cart.discount_codes || []).map(function (discount) { return discount.code; });

            var existing = (cart.discount_codes || []).find(function (discount) { return isSameCode(discount.code, code); });
            if (existing && existing.applicable) {
                showMessageInAllBoxes(texts.alreadyApplied, 'error');
                return;
            }

            var newCodes = currentCodes.filter(function (current) { return !isSameCode(current, code); }).concat(code);
            var updatedCart = await setDiscountCodes(newCodes);
            var applied = (updatedCart.discount_codes || []).find(function (discount) { return isSameCode(discount.code, code); });

            if (!applied || !applied.applicable) {
                // Roll back so an invalid code does not stay in the cart
                await setDiscountCodes(currentCodes.filter(function (current) { return !isSameCode(current, code); }));
                showMessageInAllBoxes(texts.invalid, 'error');
                renderAppliedCodes();
                return;
            }

            // The cart is re-rendered next: the new box shows the message and the code, so the drawer changes only once
            saveMessage(texts.applied, 'success');
            await refreshCart();
            document.querySelectorAll('.' + BOX_CLASS + '__input').forEach(function (input) { input.value = ''; });
            showMessageInAllBoxes(texts.applied, 'success');
            renderAppliedCodes();
        } catch (error) {
            console.warn(LOG_PREFIX, error);
            showMessageInAllBoxes(texts.error, 'error');
        } finally {
            setLoading(false);
        }
    }

    async function removeDiscountCode(code) {
        if (isApplying) return;

        setLoading(true);
        try {
            var cart = await fetchCart();
            var remainingCodes = (cart.discount_codes || [])
                .map(function (discount) { return discount.code; })
                .filter(function (current) { return !isSameCode(current, code); });

            await setDiscountCodes(remainingCodes);
            saveMessage('', null);
            await refreshCart();
            showMessageInAllBoxes('', null);
            renderAppliedCodes();
        } catch (error) {
            console.warn(LOG_PREFIX, error);
            showMessageInAllBoxes(texts.error, 'error');
        } finally {
            setLoading(false);
        }
    }

    // ---- Refresh the cart without reloading the page ----
    var CART_COUNT_SELECTOR = '#cart-icon-bubble, .cart-count-bubble, .cart-link__bubble, [data-cart-count], [data-header-cart-count], .header__cart-count, .cart-count';

    async function refreshCart() {
        try {
            if (typeof config.refreshCart === 'function') {
                await config.refreshCart(lastCart);
                afterCartRefresh();
                return;
            }
            if (isEllaTheme() && await refreshEllaCart()) {
                afterCartRefresh();
                return;
            }
            if (await refreshCartSections()) {
                afterCartRefresh();
                return;
            }
        } catch (error) {
            console.warn(LOG_PREFIX, 'Error when refreshing the cart', error);
        }
        // The cart could not be re-rendered: reload so the new prices are shown
        window.location.reload();
    }

    function afterCartRefresh() {
        injectDiscountBoxes();
        // Let other scripts (cart apps, theme code) know the cart changed
        document.dispatchEvent(new CustomEvent('tl:discount-box:updated', { detail: { cart: lastCart } }));
        log('cart refreshed without reload');
    }

    async function fetchHtml(url) {
        var res = await fetch(url, { headers: { Accept: 'text/html' } });
        if (!res.ok) throw new Error('Cannot load ' + url);
        return new DOMParser().parseFromString(await res.text(), 'text/html');
    }

    // Ella (Halo): the drawer content comes from `/cart?view=ajax_side_cart` (same as the theme)
    function isEllaTheme() {
        return /Ella/i.test(getThemeName()) || !!document.getElementById('halo-cart-sidebar');
    }

    async function refreshEllaCart() {
        var root = getRoot();

        if (!isCartPage()) {
            var drawerContent = document.querySelector('#halo-cart-sidebar .previewCart-wrapper');
            if (!drawerContent) return false;
            var drawerDoc = await fetchHtml(root + 'cart?view=ajax_side_cart');
            drawerContent.innerHTML = drawerDoc.body.innerHTML;
            drawerContent.classList.remove('is-loading');
        } else {
            var mainCart = document.getElementById('main-cart-items');
            var sectionId = mainCart && mainCart.getAttribute('data-id');
            var cartElement = document.querySelector('[data-cart]');
            if (!sectionId || !cartElement) return false;

            var pageDoc = await fetchHtml(root + 'cart?section_id=' + encodeURIComponent(sectionId));
            ['[data-cart-content] .cart', '[data-cart-total] .cart-total-subtotal', '[data-cart-total] .cart-total-grandtotal', '[data-cart-total] .cart-total-savings', '.haloCalculatorShipping']
                .forEach(function (selector) {
                    var newElement = pageDoc.querySelector(selector);
                    var currentElement = cartElement.querySelector(selector);
                    if (newElement && currentElement) currentElement.innerHTML = newElement.innerHTML;
                });
        }

        var cart = await fetchCart();
        document.querySelectorAll('[data-cart-count]').forEach(function (element) { element.textContent = cart.item_count; });
        return true;
    }

    function getSectionElement(element) {
        return element.closest('[id^="shopify-section-"]');
    }

    function getElementSelector(element) {
        var escape = function (value) { return window.CSS && CSS.escape ? CSS.escape(value) : value; };
        if (element.id) return '#' + escape(element.id);
        // First class only: state classes (is-open, active...) are not in the HTML rendered by the server
        var firstClass = (typeof element.className === 'string' ? element.className : '').split(/\s+/).filter(Boolean)[0];
        return element.tagName.toLowerCase() + (firstClass ? '.' + escape(firstClass) : '');
    }

    // Elements to update: cart drawer(s), the cart page section, cart count bubbles
    function collectCartTargets() {
        var targets = [];

        function addTarget(element, selector) {
            var section = getSectionElement(element);
            if (!section) return;
            var isCovered = targets.some(function (target) { return target.element === element || target.element.contains(element); });
            if (!isCovered) targets.push({ element: element, section: section, selector: selector, isCart: selector !== CART_COUNT_SELECTOR });
        }

        document.querySelectorAll(config.drawerSelector).forEach(function (drawer) {
            if (drawer.parentElement && drawer.parentElement.closest(config.drawerSelector)) return;
            addTarget(drawer, config.drawerSelector);
        });

        // Drawers that do not match drawerSelector, found from their checkout button
        findCheckoutButtons().forEach(function (checkoutButton) {
            var drawer = findDrawer(checkoutButton);
            if (drawer && !drawer.matches(config.drawerSelector)) addTarget(drawer, getElementSelector(drawer));
        });

        if (isCartPage()) {
            document.querySelectorAll(config.checkoutSelector + ', form[action*="/cart"]').forEach(function (element) {
                if (element.closest(config.drawerSelector)) return;
                var section = getSectionElement(element);
                if (section) addTarget(section, null);
            });
        }

        document.querySelectorAll(CART_COUNT_SELECTOR).forEach(function (element) {
            if (element.closest(config.drawerSelector)) return;
            addTarget(element, CART_COUNT_SELECTOR);
        });

        return targets;
    }

    function findNewElement(newSection, target) {
        if (!newSection) return null;
        if (target.element === target.section) return newSection;

        if (target.element.id) {
            var byId = newSection.querySelector('#' + (window.CSS && CSS.escape ? CSS.escape(target.element.id) : target.element.id));
            if (byId) return byId;
        }
        var index = Array.prototype.indexOf.call(target.section.querySelectorAll(target.selector), target.element);
        return index === -1 ? null : newSection.querySelectorAll(target.selector)[index] || null;
    }

    // Section Rendering API: fetch the sections again and replace the content of each target
    // (the target element itself is kept, so an open drawer stays open)
    async function refreshCartSections() {
        var targets = collectCartTargets();
        if (!targets.some(function (target) { return target.isCart; })) return false;

        var sectionIds = [];
        targets.forEach(function (target) {
            var sectionId = target.section.id.replace('shopify-section-', '');
            if (sectionIds.indexOf(sectionId) === -1) sectionIds.push(sectionId);
        });

        var htmlBySection = {};
        // The Section Rendering API returns at most 5 sections per request
        for (var i = 0; i < sectionIds.length; i += 5) {
            var res = await fetch(window.location.pathname + '?sections=' + encodeURIComponent(sectionIds.slice(i, i + 5).join(',')), {
                headers: { Accept: 'application/json' }
            });
            if (!res.ok) return false;
            Object.assign(htmlBySection, await res.json());
        }

        var refreshedCart = false;
        var parser = new DOMParser();
        targets.forEach(function (target) {
            var html = htmlBySection[target.section.id.replace('shopify-section-', '')];
            if (!html) return;
            var doc = parser.parseFromString(html, 'text/html');
            var newElement = findNewElement(doc.getElementById(target.section.id) || doc.body, target);
            if (!newElement) return;

            target.element.innerHTML = newElement.innerHTML;
            if (target.isCart) refreshedCart = true;
        });

        return refreshedCart;
    }

    // ---- Find the checkout buttons and the drawers ----
    // By selector, or by their text for drawers that use a plain button / custom markup
    var CHECKOUT_TEXT = /^(check ?out|proceed to checkout|continue to checkout|go to checkout|finalizar|finalizar compra|finalizar pedido|finalizar la compra|ir para o checkout|ir para o pagamento|fechar pedido|tramitar pedido|passer la commande|zur kasse|thanh toán)$/i;

    function findCheckoutButtons() {
        var buttons = Array.prototype.slice.call(document.querySelectorAll(config.checkoutSelector));
        document.querySelectorAll('button, a, input[type="submit"], [role="button"]').forEach(function (element) {
            if (buttons.indexOf(element) !== -1 || element.closest('.' + BOX_CLASS)) return;
            var text = String(element.value || element.textContent || '').replace(/\s+/g, ' ').replace(/^[^\wÀ-ỹ]+|[^\wÀ-ỹ]+$/g, '');
            if (text && text.length <= 40 && CHECKOUT_TEXT.test(text)) buttons.push(element);
        });
        // Keep the outermost element when a button and its inner link both match
        return buttons.filter(function (button) {
            return !buttons.some(function (other) { return other !== button && other.contains(button); });
        });
    }

    var CART_NAME = /cart|carrinho|carrito|sacola|basket|panier|warenkorb|gio-hang|giohang/i;
    var DRAWER_NAME = /drawer|sidebar|side-|mini|slide|flyout|offcanvas|off-canvas|popup|modal|panel|ajax|overlay|dialog/i;

    function getElementName(element) {
        var className = typeof element.className === 'string' ? element.className : (element.getAttribute('class') || '');
        return element.tagName + ' ' + (element.id || '') + ' ' + className;
    }

    // The drawer around an element: drawerSelector first, otherwise the closest element named like a cart drawer
    function findDrawer(element) {
        var drawer = element.closest(config.drawerSelector);
        if (drawer) return drawer;
        if (isCartPage()) return null;

        var cartElement = null;
        for (var node = element.parentElement; node && node !== document.body; node = node.parentElement) {
            if (/^shopify-section-/.test(node.id)) break;
            var name = getElementName(node);
            if (!CART_NAME.test(name)) continue;
            if (DRAWER_NAME.test(name)) return node;
            if (!cartElement && node.tagName !== 'FORM') cartElement = node;
        }
        return cartElement;
    }

    // ---- Keep the checkout button on screen ----
    // The box makes the drawer footer taller. When the drawer has a fixed height, the footer (and the checkout
    // button) would be pushed below the screen, so the scrolling items list is made shorter by the same amount.
    var FIT_ATTRIBUTE = 'data-tl-db-max-height';

    function findItemsList(drawer, box) {
        var selector = config.itemsListSelector || (isEllaTheme() ? '.previewCart' : null);
        if (selector) return drawer.querySelector(selector);

        // The largest scrollable element of the drawer that does not contain the box
        var candidates = Array.prototype.filter.call(drawer.querySelectorAll('*'), function (element) {
            if (element.contains(box) || box.contains(element) || !element.clientHeight) return false;
            var overflowY = window.getComputedStyle(element).overflowY;
            return overflowY === 'auto' || overflowY === 'scroll';
        });
        candidates.sort(function (a, b) { return b.clientHeight - a.clientHeight; });
        return candidates[0] || null;
    }

    function fitDrawer(box) {
        var drawer = findDrawer(box);
        if (!drawer) return;
        var list = findItemsList(drawer, box);
        if (!list) return;

        // The footer: the ancestor of the box that sits next to the items list
        var footer = box;
        while (footer.parentElement && footer.parentElement !== drawer && !footer.parentElement.contains(list)) footer = footer.parentElement;

        var footerRect = footer.getBoundingClientRect();
        var listRect = list.getBoundingClientRect();
        if (!footerRect.height || !listRect.height) return; // drawer closed / hidden

        var drawerRect = drawer.getBoundingClientRect();
        var bottomLimit = Math.min(window.innerHeight, drawerRect.bottom || window.innerHeight);
        var overflow = footerRect.bottom - bottomLimit;
        var applied = list.hasAttribute(FIT_ATTRIBUTE);
        if (overflow <= 1 && !applied) return;

        var maxHeight = Math.max(120, Math.floor(listRect.height - overflow));
        if (applied && Math.abs(maxHeight - Number(list.getAttribute(FIT_ATTRIBUTE))) < 2) return;

        list.style.setProperty('max-height', maxHeight + 'px', 'important');
        list.style.setProperty('overflow-y', 'auto', 'important');
        list.setAttribute(FIT_ATTRIBUTE, String(maxHeight));
        log('drawer fitted, items list max-height:', maxHeight);
    }

    function fitAllDrawers() {
        document.querySelectorAll('.' + BOX_CLASS).forEach(function (box) {
            try { fitDrawer(box); } catch (error) { console.warn(LOG_PREFIX, error); }
        });
    }

    var fitTimer = null;
    function scheduleFit() {
        clearTimeout(fitTimer);
        // Run after drawer open animations
        fitTimer = setTimeout(function () {
            fitAllDrawers();
            setTimeout(fitAllDrawers, 400);
        }, 50);
    }

    // ---- Insert the boxes ----
    function isVisible(element) {
        return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
    }

    // A horizontal row (flex row / multi-column grid) around the checkout button, e.g. "View cart" + "Check out"
    // side by side, or a flex wrapper with only the button: the box would sit next to the button, so it goes
    // above the whole row instead
    function isHorizontalRow(parent, child) {
        var style = window.getComputedStyle(parent);
        if (/flex/.test(style.display) && !/column/.test(style.flexDirection)) return true;
        if (/grid/.test(style.display) && String(style.gridTemplateColumns || '').trim().split(/\s+/).length > 1) return true;

        // Inline buttons on the same line
        var others = Array.prototype.filter.call(parent.children, function (element) {
            return element !== child && !element.classList.contains(BOX_CLASS) && element.tagName !== 'SCRIPT' && element.tagName !== 'TEMPLATE' && window.getComputedStyle(element).display !== 'none';
        });
        if (!others.length || !isVisible(child)) return false;
        var rect = child.getBoundingClientRect();
        return others.some(function (element) {
            if (!isVisible(element)) return false;
            var otherRect = element.getBoundingClientRect();
            return otherRect.top < rect.bottom && otherRect.bottom > rect.top;
        });
    }

    // Default position: right above the checkout button, or above the row it sits in
    function getCheckoutAnchor(checkoutButton, container) {
        var anchor = checkoutButton;
        while (anchor.parentElement && anchor.parentElement !== container && anchor.parentElement !== document.body && isHorizontalRow(anchor.parentElement, anchor)) {
            anchor = anchor.parentElement;
        }
        return anchor;
    }

    function createBox() {
        var box = document.createElement('div');
        box.className = BOX_CLASS;
        box.innerHTML =
            '<div class="' + BOX_CLASS + '__form">' +
                '<input type="text" class="' + BOX_CLASS + '__input" autocomplete="off" autocapitalize="characters" spellcheck="false">' +
                '<button type="button" class="' + BOX_CLASS + '__apply"></button>' +
            '</div>' +
            '<p class="' + BOX_CLASS + '__message" role="status" aria-live="polite" hidden></p>' +
            '<ul class="' + BOX_CLASS + '__codes"></ul>';

        var input = box.querySelector('.' + BOX_CLASS + '__input');
        var button = box.querySelector('.' + BOX_CLASS + '__apply');
        input.placeholder = texts.placeholder;
        input.setAttribute('aria-label', texts.placeholder);
        button.textContent = texts.apply;
        button.disabled = isApplying;

        button.addEventListener('click', function () { applyDiscountCode(input.value); });
        // The box can sit inside the cart <form>: Enter must apply the code, not submit the form (go to checkout)
        input.addEventListener('keydown', function (event) {
            if (event.key === 'Enter') {
                event.preventDefault();
                event.stopPropagation();
                applyDiscountCode(input.value);
            }
        });

        if (lastMessage && Date.now() - lastMessage.time < MESSAGE_DURATION) showMessage(box, lastMessage.text, lastMessage.type);
        return box;
    }

    function injectDiscountBoxes() {
        if (!config.enabled) return;

        var containers = new Set();
        var hasNewBox = false;

        findCheckoutButtons().forEach(function (checkoutButton) {
            var drawer = findDrawer(checkoutButton);
            if (drawer ? !config.cartDrawer : (!config.cartPage || !isCartPage())) return;

            // Cart page buttons can be outside the <form> (form="cart" attribute): use their section then
            var container = drawer || checkoutButton.closest('form') || getSectionElement(checkoutButton) || checkoutButton.parentElement;
            if (!container || containers.has(container)) return;
            containers.add(container);
            if (container.querySelector('.' + BOX_CLASS)) return;

            var box = createBox();
            var list = !config.insertBefore && config.appendTo && container.querySelector(config.appendTo);
            if (list) {
                box.classList.add(BOX_CLASS + '--in-list');
                list.appendChild(box);
            } else {
                var anchor = (config.insertBefore && container.querySelector(config.insertBefore)) || getCheckoutAnchor(checkoutButton, container);
                if (!anchor.parentNode) return;
                anchor.parentNode.insertBefore(box, anchor);
            }
            hasNewBox = true;
        });

        if (!hasNewBox) return scheduleFit();
        if (lastCart) renderAppliedCodes();
        else fetchCart().then(renderAppliedCodes).catch(function () {});
        fitAllDrawers();
        scheduleFit();
    }

    function init() {
        if (!config.enabled) return;
        injectStyle();
        injectDiscountBoxes();

        // Themes re-render the drawer / cart page after every cart change: add the box back when it is gone.
        // Class changes = a drawer opening / closing: check the checkout button is still on screen.
        var injectTimer = null;
        var boxes = document.getElementsByClassName(BOX_CLASS);
        var boxCount = boxes.length;
        new MutationObserver(function () {
            // A box was removed (cart HTML replaced): add it back right away, before the browser paints
            if (boxes.length < boxCount) injectDiscountBoxes();
            boxCount = boxes.length;

            clearTimeout(injectTimer);
            injectTimer = setTimeout(function () {
                injectDiscountBoxes();
                boxCount = boxes.length;
            }, 100);
        }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'open', 'aria-hidden'] });

        window.addEventListener('resize', scheduleFit);
    }

    // Debug helper: run `tlDiscountBoxDebug()` in the browser console
    window.tlDiscountBoxDebug = function () {
        console.log(LOG_PREFIX, {
            checkoutButtons: findCheckoutButtons(),
            drawers: findCheckoutButtons().map(findDrawer),
            boxes: document.querySelectorAll('.' + BOX_CLASS).length,
            cart: lastCart
        });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
})();
